module.exports = __webpack_public_path__ + "static/media/_DSC6105.988bbb9d.jpg";